import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 2h-10a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3 -3v-14a3 3 0 0 0 -3 -3z","key":"svg-0"}]]

/**
 * IconRectangleVerticalFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItcmVjdGFuZ2xlLXZlcnRpY2FsIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNyAyaC0xMGEzIDMgMCAwIDAgLTMgM3YxNGEzIDMgMCAwIDAgMyAzaDEwYTMgMyAwIDAgMCAzIC0zdi0xNGEzIDMgMCAwIDAgLTMgLTN6IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/rectangle-vertical-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconRectangleVerticalFilled = createReactComponent('filled', 'rectangle-vertical-filled', 'RectangleVerticalFilled', __iconNode);

export default IconRectangleVerticalFilled;